import { createSelector } from '@ngrx/store';
import { collectionTypeState } from '../root';

import * as Utils from '@shared/core/utils';
import * as Statics from '@shared/core/statics';

export const isCollectionTypePickup = createSelector(collectionTypeState, (collectionType) => {
    const config = new Statics.ConfigStatic().current;

    if (!config || !collectionType?.orderTypeId) return false;

    return new Utils.CollectionTypeGroupDetector(collectionType.orderTypeId, config).isPickup();
});
